import { ManageDeviceActionTypes } from '../actions/index.model'

export const getDevicesDetails = () => ({
  type: ManageDeviceActionTypes.GET_MANAGE_DEVICE_DETAILS,
})

export const updateManageDevicesDetails = (data: any) => ({
  type: ManageDeviceActionTypes.UPDATE_MANAGE_DEVICES_DETAILS,
  data,
})

export const sigingOutDevice = (data: any) => ({
  type: ManageDeviceActionTypes.SIGNINGOUT_DEVICE,
  data,
})

export const updateSignOutDeviceDetails = (data: any) => ({
  type: ManageDeviceActionTypes.UPDATE_SIGNOUT_DEVICE_DETAILS,
  data,
})

export const resetSignOutDevice = () => ({
  type: ManageDeviceActionTypes.RESET_SIGNOUT_DEVICE,
})
